exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".achievements img{\r\n  width: 100px;\r\n  height: auto;\r\n}\r\n\r\n.achievements p {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.achievements .achievement-num {\r\n  color: #84baac;\r\n  font-weight: 600;\r\n}\r\n\r\n.num-zh {\r\n  font-size: 1.7rem;\r\n  padding-bottom: .1rem;\r\n}\r\n\r\n.num-en {\r\n  font-size: 1.8rem;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .achievements img{\r\n    width: 60px;\r\n    height: auto;\r\n  }\r\n\r\n  .num-zh {\r\n    font-size: 1.1rem;\r\n    padding-bottom: .1rem;\r\n  }\r\n\r\n  .num-en {\r\n    font-size: 1.2rem;\r\n  }\r\n\r\n  .achievement-desc {\r\n    font-size: .7rem;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/home/achievement/achievement.component.css
// module id = ../../../../../src/app/components/home/achievement/achievement.component.css
// module chunks = main